// extracted by mini-css-extract-plugin
export default {"imageContainer":"C2-z","summaryPar":"D2-z","ratingCategories":"E2-z","reviewerInfo":"F2-z","reviewTypes":"G2-z","expanded":"H2-z"};